import { Link } from "@tanstack/react-router";
import { Zap } from "lucide-react";

type LogoSize = "sm" | "md" | "lg";

const iconSizeClasses = {
  sm: "size-3",
  md: "size-4",
  lg: "size-6",
};

interface LogoProps {
  size?: LogoSize;
  showText?: boolean;
  className?: string;
}

export function Logo({ size = "md", showText = true, className = "" }: LogoProps) {
  return (
    <div className={`flex items-center gap-2 font-semibold ${className}`}>
      <div className="bg-primary text-primary-foreground flex aspect-square items-center justify-center rounded-lg p-1.5">
        <Zap className={iconSizeClasses[size]} />
      </div>
      {showText && <span>QuickPrompt</span>}
    </div>
  );
}

interface LogoLinkProps extends LogoProps {
  to?: string;
}

export function LogoLink({
  to = "/dashboard",
  size = "md",
  showText = true,
  className = "",
}: LogoLinkProps) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 font-semibold transition-opacity hover:opacity-80 ${className}`}
    >
      <div className="bg-primary text-primary-foreground flex aspect-square items-center justify-center rounded-lg p-1.5">
        <Zap className={iconSizeClasses[size]} />
      </div>
      {showText && <span>QuickPrompt</span>}
    </Link>
  );
}
